module.exports = __webpack_public_path__ + "img/blog3.e4fa9c6.png";